import PubSub from "underpub-js";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

var HeroSplit = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-HeroSplit',
  };

  $.extend(true, this.options, options);

};

HeroSplit.prototype.init = function () {

  var self = this;

  self.$button = self.options.$el.find(`.${self.options.baseClass}__button`);
  self.$nextSection = self.options.$el.next();

  self.$button.on('click', () => {
    gsap.to(window, {
      scrollTo: self.$nextSection[0],
      duration: 1,
      ease: "expo.out"
    })
  })

};

export default HeroSplit;